const AvailableStorageUnits = [
  { value: 'MegaBytes', label: 'MB', factor: 10 ** 6 },
  { value: 'GigaBytes', label: 'GB', factor: 10 ** 9 },
  { value: 'TeraBytes', label: 'TB', factor: 10 ** 12 }
];

export default AvailableStorageUnits;
